import { FC } from 'react'
import { Paper, Grid, ThemeProvider, createTheme } from '@mui/material'
import { EventsData, Pallet } from './types'
import Day from './Day'
import ExtraDays from './ExtraDays'
import useEventCalendar from './useEventCalendar'
import Controls from './Controls'
import moment, { Moment } from 'moment'
import { EventCalendarContext } from './EventCalendarContext'

export interface EventCalendarProps {
  readonly?: boolean
  pallet?: Pallet
  elevation?: number
  width?: number | string
  dataSource: EventsData
  currentDate: Date
  setCurrentDate: (date: Moment) => void
  currentMonth: number
  setCurrentMonth: (number: number) => void
  currentYear: number
  setCurrentYear: (number: number) => void
  colors: number[]
  onDataChange?: (events: EventsData) => void
  showEventPopup?: boolean
  defaultDate?: Date | Moment
}

const EventCalendar: FC<EventCalendarProps> = ({
  readonly = false,
  pallet,
  elevation = 0,
  width = '90%',
  dataSource: data,
  currentDate,
  setCurrentDate,
  currentMonth,
  setCurrentMonth,
  currentYear,
  setCurrentYear,
  colors,
  onDataChange,
  showEventPopup = true,
  defaultDate = moment(),
}) => {
  if (!data) throw new Error('dataSource is required')

  const { changeMonth, date, daysGrid } = useEventCalendar(defaultDate)
  var n=0;
  const theme = createTheme({
    palette: {
      primary: {
        main: pallet?.primary || '#1976d2',
      },
      secondary: {
        main: pallet?.secondary || '#9c27b0',
      },
      divider: pallet?.primary || '#1976d2',
    },
  })
  function incrementDays(c: number ){
    n=n+c;
  }

  return (
    <EventCalendarContext.Provider
      value={{
        readonly,
        data,
        currentDate,
        setCurrentDate,
        onDataChange,
        currentMonth,
        setCurrentMonth,
        currentYear,
        setCurrentYear,
        colors,
        showEventPopup,
      }}
    >
      {/* {data.length} */}
      <ThemeProvider theme={theme}>
        <Paper
          sx={{ width, border: '1px solid rgba(0, 145, 255, 1)' }}
          elevation={elevation}
        >
          <Controls changeMonth={changeMonth}  date={date} currentMonth={currentMonth} setCurrentMonth={setCurrentMonth} currentYear={currentYear} setCurrentYear={setCurrentYear}/>
          <Grid container>
            {daysGrid?.map((item, i) =>
              item?.no ? (
                <>
                <Day
                  daysGridLength={daysGrid.length}
                  i={i}
                  item={item}
                  key={i}
                  events={data?.filter((d) => item.date.isSame(moment(d?.date), 'day'))}
                  currentDate={currentDate}
                  setCurrentDate={setCurrentDate}
                  colors={colors.slice(n,colors.length)}
                />
                {incrementDays(data?.filter((d) => item.date.isSame(moment(d?.date), 'day')).length)}
                </>
              ) : (
                <ExtraDays daysGridLength={daysGrid.length} i={i} key={i} />
              )
            )}
          </Grid>
        </Paper>
      </ThemeProvider>
    </EventCalendarContext.Provider>
  )
}

export default EventCalendar
